exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-link[data-v-41482700]{cursor:pointer}[data-v-41482700] .v-badge__badge{border-radius:50px;width:36px;height:36px}.v-badge--avatar .v-badge__badge .v-avatar[data-v-41482700]{height:36px!important;width:36px!important;max-width:unset!important}", ""]);

// exports
